module.exports = __webpack_public_path__ + "static/media/ic_location_on_black_36px.1ef33969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_location_on_black_36px.svg
// module id = 797
// module chunks = 0